//@ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('contacts.roles.role', {
        url: '/{roleId}',
        views: {
            "contactView@contacts": {
                templateUrl: 'main/contacts/roles/role/role.tpl.html',
                controller: 'RoleController as vm'
            }
        },
        resolve: {
            role: roleResolver,
            claims: claimsResolver,
            widgets: widgetsResolver,
            dataSources: dataSourcesResolver
        }
    });
}

//@ngInject
function roleResolver(RolesApiService, $stateParams) {
    return RolesApiService.getRole($stateParams.roleId);
}

//@ngInject
function claimsResolver(RolesApiService) {
    return RolesApiService.getAllClaims();
}

//@ngInject
function widgetsResolver(RolesApiService) {
    return RolesApiService.getAllWidgets();
}

//@ngInject
function dataSourcesResolver(RolesApiService) {
    return RolesApiService.getAllDataSources();
}

//@ngInject
function RoleController($translate, TranslateHelper, $timeout, $scope, AuthService, role, claims, RolesApiService, loadSpinnerService, widgets, dataSources) {
    var vm = this;

    vm.role = role;
    vm.claims = claims;

    vm.isSaving = false;
    vm.readTypes = ['read', 'readList'];
    vm.writeTypes = ['create', 'update', 'delete'];

    vm.objectTypes = [];
    vm.claimsRowData = [];
    vm.claimTypes = [];

    vm.checkChanged = checkChanged;
    vm.saveRole = saveRole;
    vm.canAccess = AuthService.canAccess;
    vm.widgets = widgets;
    vm.dataSources = dataSources;

    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactRoleView') !== 'false';
    vm.canUpdateRole = AuthService.canAccess('role', 'update');

    TranslateHelper.isReady().then(function(){
        activate();
    });

    function activate() {
        _.forEach(vm.claims, function(claim) {
            if (!_.find(vm.claimTypes, function(claimType) { return claimType === claim.claimType; })) {
                vm.claimTypes.push(claim.claimType);
            }
            if (!_.find(vm.objectTypes, function(objectType) { return objectType === claim.objectType; })) {
                vm.objectTypes.push(claim.objectType);
            }
        });

        loadClaimsGridData();
    }

    function checkChanged(row, type){
        if(type === 'read'){
            if(!row.read)
                row.write = false;
        }
        else if(type === 'write'){
            if(row.write)
                row.read = true;
        }
    }

    function saveRole(){
        if(vm.isSaving)
            return;

        vm.isSaving = true;
        loadSpinnerService.start('mainSpinner');

        var claimsToSave = [];

        _.forEach(vm.claimsRowData, function(rowData) {
            var objectType = rowData.rowHeaderSystemType;
            var typesToAdd = [];

            if(rowData.read)
                typesToAdd = typesToAdd.concat(vm.readTypes);
            if(rowData.write)
                typesToAdd = typesToAdd.concat(vm.writeTypes);

            _.forEach(typesToAdd, function(claimType){
                var foundClaim = _.find(vm.claims, function(claim){
                    return claim.objectType === objectType && claim.claimType === claimType
                })
                claimsToSave.push(foundClaim);
            });
        });

        vm.role.claims = claimsToSave;
        RolesApiService.updateRole(vm.role).then(function(response) {

        }, function(error) {
            console.log(error);
        }).finally(function() {
            vm.isSaving = false;
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function loadClaimsGridData() {
        _.forEach(vm.objectTypes, function(objectType) {
            
            var r = {
                rowHeaderSystemType: objectType,
                rowHeaderLabel: $translate.instant('role.' + objectType) 
            };

            $translate(r.rowHeaderLabel).then(function(translated) {
                r.rowHeaderLabel = translated;
            }).finally(function(){
                _.forEach(vm.claimTypes, function(claimType) {
                    if (_.find(vm.role.claims, function(claim) { return claim.claimType === claimType && claim.objectType === objectType; })) {
                        if(_.includes(vm.readTypes, claimType))
                            r.read= true;
                        else if(_.includes(vm.writeTypes, claimType))
                            r.write = true;
                    } else {
                        if(_.includes(vm.readTypes, claimType))
                            r.read = false;
                        else if(_.includes(vm.writeTypes, claimType))
                            r.write = false;
                    }
                });
                vm.claimsRowData.push(r);
            });
        });
    }
}


angular.module('contacts.roles.role', [])
    .config(stateConfig)
    .controller('RoleController', RoleController);
